import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { KeyRound, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 10) { setError("Le mot de passe doit contenir au moins 10 caractères."); return; }
    if (pwd !== pwd2) { setError("Les deux mots de passe ne correspondent pas."); return; }
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, new_password: pwd }); setDone(true); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4" data-testid="reset-password-page">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl">
        <div className="flex items-center gap-2 text-slate-900 font-bold text-xl mb-1"><KeyRound className="h-5 w-5 text-sky-600" /> Nouveau mot de passe</div>
        <p className="text-sm text-slate-500 mb-6">Path-Intelligent — choisissez un mot de passe d'au moins 10 caractères.</p>
        {done ? (
          <div className="space-y-4" data-testid="reset-password-success">
            <div className="flex items-center gap-2 text-emerald-700 text-sm"><CheckCircle2 className="h-5 w-5" /> Mot de passe modifié. Toutes vos sessions ont été fermées.</div>
            <Link to="/login" className="text-sm font-semibold text-sky-700 underline" data-testid="reset-password-login-link">Se connecter</Link>
          </div>
        ) : !token ? (
          <div className="text-sm text-red-600" data-testid="reset-password-invalid">Lien invalide. Refaites une demande depuis « Mot de passe oublié ? ».</div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Nouveau mot de passe</Label><Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} autoComplete="new-password" data-testid="reset-password-input" /></div>
            <div><Label>Confirmer</Label><Input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} autoComplete="new-password" data-testid="reset-password-confirm" /></div>
            {error && <div className="text-sm text-red-600" data-testid="reset-password-error">{error}</div>}
            <Button type="submit" disabled={busy} className="w-full" style={{ background: "#1E3A6E" }} data-testid="reset-password-submit">Enregistrer</Button>
          </form>
        )}
      </div>
    </div>
  );
}
